// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-group[data-v-6c3f4df6] {\n  margin-bottom: 1.5rem;\n}\n.text-primary[data-v-6c3f4df6] {\n  color: #007bff;\n}\n", ""]);
// Exports
module.exports = exports;
